module.exports = __webpack_public_path__ + "static/police-wardlow-fc3b0db638e90a4b0b4ce02dcb976c83.gif";